import allLocales from "../I18n/locales";

const getLocale = (auth, match, forceUrl) => {
    const paramsLocale = match?.params?.locale;

    if (forceUrl && paramsLocale) {
        return paramsLocale;
    }

    const userLocale = auth?.user?.profile?.locale?.split("-")[0];
    const browserLocale = navigator?.language?.split("-")[0];
    const defaultLocale = "en";

    const allLocalesArray = allLocales().map((locale) => locale.id);

    let locale = null;

    if (allLocalesArray.includes(userLocale)) {
        locale = userLocale;
    } else if (allLocalesArray.includes(browserLocale)) {
        locale = browserLocale;
    } else if (allLocalesArray.includes(paramsLocale)) {
        locale = paramsLocale;
    } else {
        locale = defaultLocale;
    }

    return locale;
};

export { getLocale };
